import { useNavigate } from "react-router-dom";
import DynamicFormPage from "../../components/DynamicFormPage";
import { useParams } from "react-router-dom";
import { createStoneVariation } from "../../helpers/http_stone_variations_requests";
import { reaisToCents } from "../../utils/functions";

export default function StoneVariationNew() {

    const { id } = useParams();

    const navigate = useNavigate();

    const formFieldList = [
        {
            title: "Informações da Pedra",
            fields: [
                {
                    name: "name",
                    label: "Nome",
                    type: "text",
                    required: true,
                },
                {
                    name: "size",
                    label: "Tamanho",
                    type: "number",
                    end_adornment: "mm",
                    required: true
                },
                {
                    name: "price",
                    label: "Preço",
                    type: "text",
                    mask: "currency",
                    required: true
                },
                {
                    name: "description",
                    label: "Descrição",
                    type: "text",
                    multiline: true,
                    rows: 5,
                    fullWidth: true,
                    required: true,
                },
            ]
        },
    ];

    const handleSubmit = (data) => {
        createStoneVariation({ ...data, id: id, price: reaisToCents(data.price) }, () => navigate('/pedra-variacoes/' + id))
    };

    return <DynamicFormPage title={"Variação de Pedra - Cadastro"} onSubmit={handleSubmit} formFieldList={formFieldList} onCancel={() => navigate(-1)} />;

};
